import {
    DeleteTwoTone,
    EditTwoTone,
    QuestionCircleOutlined,
} from "@ant-design/icons";
import {
    Button,
    DatePicker,
    Form,
    Input,
    Modal,
    notification,
    Popconfirm,
    Select,
    Skeleton,
} from "antd";
import { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import CustomTable from "../common/Table";
import { timeZoneOptions } from "../../services/util";
import { TeamMangementContext } from ".";
import moment from "moment";

const { Option } = Select;

function Shift() {
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [formData, setFormData] = useState({ staff_id, page: 0, limit: 10 });
    const [shiftData, setShiftData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [modalTitle, setModalTitle] = useState("Add Shift");
    const [form] = Form.useForm();
    const { shiftFormVisible, setShiftFormVisible } =
        useContext(TeamMangementContext);

    const {
        status: shiftStatus,
        data: shiftRes,
        refetch: getShift,
    } = useQuery(
        "shift",
        async () => {
            return await HTTP("/teams/getShifts", { ...formData });
        },
        { enabled: false },
    );

    const columns = [
        { title: "Name", dataIndex: "name", key: "name", sorter: () => {} },
        {
            title: "Timing",
            render: (text, record) => {
                return <p>{`${record.timings_from} - ${record.timings_to}`}</p>;
            },
        },
        {
            title: "Time Zone",
            dataIndex: "time_zone",
            key: "time_zone",
            sorter: () => {},
        },
        {
            title: "Action",
            render: (text, record) => {
                return (
                    <>
                        <Popconfirm
                            title="Are you sure want to delete?"
                            onConfirm={() => deleteShift(record.id)}
                            icon={
                                <QuestionCircleOutlined
                                    style={{
                                        color: "red",
                                    }}
                                />
                            }
                        >
                            <DeleteTwoTone className="actionIcon actionIconDelete" />
                        </Popconfirm>
                        <EditTwoTone
                            className="actionIcon"
                            id={record.id}
                            onClick={() => openEditForm(record)}
                        />
                    </>
                );
            },
        },
    ];

    async function deleteShift(id) {
        const { success, message } = await HTTP("/teams/deleteShift", {
            staff_id,
            id,
        });
        let type = "error";
        if (success) {
            type = "info";
        }
        notification[type]({ message });
        getShift();
    }

    function openEditForm(record) {
        const timing = [
            moment(record.timings_from, "HH:mm"),
            moment(record.timings_to, "HH:mm"),
        ];
        form.setFieldsValue({
            name: record.name,
            timing,
            timings_from: moment(record.timings_from, "HH:mm"),
            timings_to: moment(record.timings_to, "HH:mm"),
            id: record.id,
            time_zone: record.time_zone,
        });
        setModalTitle("Edit Shift");
        setShiftFormVisible(true);
    }

    async function handleSubmit(values) {
        // [values.timings_from, values.timings_to] = values.timing;
        values.timings_to = moment(values.timings_to).format("HH:mm");
        values.timings_from = moment(values.timings_from).format("HH:mm");
        delete values.timing;
        let url = "/teams/addShift";
        if (values.id) {
            url = "/teams/updateShift";
        }
        const { success, message } = await HTTP(url, {
            staff_id,
            ...values,
        });
        let type = "error";
        if (success) {
            type = "info";
        }
        notification[type]({ message });
        closeForm();
        getShift();
    }

    function closeForm() {
        setShiftFormVisible(false);
        setModalTitle("Add Shift");
        form.resetFields();
    }

    useEffect(() => {
        getShift();
    }, []);

    useEffect(() => {
        getShift();
    }, [formData]);

    useEffect(() => {
        if (shiftStatus === "success") {
            const { data, total } = shiftRes;
            setShiftData(data);
            setTotalRecords(total);
        }
    }, [shiftStatus, shiftRes]);

    function handleTableChange(pagination, _, sorter) {
        const { current, pageSize } = pagination;
        const { order, field } = sorter;
        const others = {
            page: current - 1,
            limit: pageSize,
        };
        if (order !== undefined) {
            others.sorting = order === "ascend" ? 1 : 2;
            others.sort_by = field;
        }
        setFormData({ ...formData, ...others });
    }

    return (
        <>
            {shiftStatus !== "idle" && shiftStatus !== "loading" ? (
                <CustomTable
                    columns={columns}
                    tableData={shiftData}
                    noOfrecords={totalRecords}
                    handleTableChange={handleTableChange}
                    rowKey="id"
                    isScroll
                />
            ) : (
                <Skeleton active title={false} paragraph={{ rows: 10 }} />
            )}

            <Modal
                open={shiftFormVisible}
                title={modalTitle}
                footer=""
                destroyOnClose={true}
                onCancel={closeForm}
            >
                <Form form={form} onFinish={handleSubmit}>
                    <Form.Item name="id" className="hidden">
                        <Input id="id" disabled />
                    </Form.Item>
                    <Form.Item
                        label="Name"
                        name="name"
                        rules={[
                            { required: true, message: "Please Add Name..!" },
                        ]}
                    >
                        <Input id="name" />
                    </Form.Item>

                    <Form.Item
                        name="timings_from"
                        label="From"
                        rules={[
                            {
                                required: true,
                                message: "Please Select Time..!",
                            },
                        ]}
                    >
                        <DatePicker
                            allowClear={false}
                            id="timings_from"
                            picker="time"
                            format={"HH:mm"}
                        />
                    </Form.Item>
                    <Form.Item
                        name="timings_to"
                        label="To"
                        rules={[
                            {
                                required: true,
                                message: "Please Select Time..!",
                            },
                        ]}
                    >
                        <DatePicker
                            allowClear={false}
                            id="timings_to"
                            picker="time"
                            format={"HH:mm"}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Time Zone"
                        name="time_zone"
                        rules={[
                            {
                                required: true,
                                message: "Please Select Time Zone..!",
                            },
                        ]}
                    >
                        <Select id="time_zone">
                            {timeZoneOptions.map((e) => (
                                <Option key={e} value={e}>
                                    {e}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                            offset: 8,
                            span: 16,
                        }}
                    >
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}
export default Shift;
